/* Earth Angel Frequencies: mentorship feature banner (placement + lightweight video) */
document.querySelectorAll('[data-eaf]').forEach(function (root) {
  var f = root.querySelector('[data-eaf-feature]');
  var body = root.querySelector('[data-eaf-body]');
  if (!f || !body) return;

  /* Move the banner to the middle of the article: before the H2 closest to the halfway point */
  var kids = [].filter.call(body.children, function (el) { return el !== f; });
  if (kids.length >= 6) {
    var total = 0, i;
    for (i = 0; i < kids.length; i++) total += kids[i].textContent.length;
    var run = 0, best = null, bestDist = 1;
    for (i = 0; i < kids.length; i++) {
      if (i > 0 && kids[i].tagName === 'H2') {
        var d = Math.abs(run / total - 0.5);
        if (d < bestDist) { bestDist = d; best = kids[i]; }
      }
      run += kids[i].textContent.length;
    }
    if (!best) {
      run = 0;
      for (i = 0; i < kids.length; i++) {
        run += kids[i].textContent.length;
        if (run >= total / 2 && kids[i + 1]) { best = kids[i + 1]; break; }
      }
    }
    if (best) body.insertBefore(f, best);
  }

  /* Video: load only near the screen; skip on data-saver, slow networks and reduced motion */
  var v = f.querySelector('video[data-src]');
  if (!v) return;
  var conn = navigator.connection || {};
  var slow = conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (slow || reduce || !('IntersectionObserver' in window)) return;

  v.muted = true;
  v.addEventListener('playing', function () { v.classList.add('is-on'); });
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        if (!v.src) { v.src = v.getAttribute('data-src'); v.load(); }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (v.src) {
        v.pause();
      }
    });
  }, { rootMargin: '300px' }).observe(f);
});